"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInWithTeamboard = void 0;
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_pages_1 = __importDefault(require("@opsbase/lib-pages"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const react_useauth_1 = __importDefault(require("@opsbase/react-useauth"));
const useAppState_1 = __importDefault(require("@opsbase/web-app-state/useAppState"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const EnterCode_1 = __importDefault(require("./EnterCode"));
function SignInWithTeamboard() {
    const { app } = (0, useAppState_1.default)();
    const [code, setCode] = (0, react_1.useState)('');
    const submitRef = (0, react_1.useRef)();
    const auth = (0, react_useauth_1.default)();
    const { goTo } = (0, useNav_1.default)();
    const isValid = code.length === 9;
    const handleGoTo = (0, useCallforward_1.default)(url => () => goTo(url), [goTo]);
    const handleSubmit = (0, react_1.useCallback)(() => {
        auth.api
            .teamboardSignin(app, code)
            .then(() => goTo(lib_pages_1.default.TODO))
            .catch(doNothing_1.default);
    }, [app, auth.api, code, goTo]);
    return (react_1.default.createElement(Vertical_1.default, { gutter: true, centered: true },
        react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('welcome-setup-teamboard')),
        react_1.default.createElement(EnterCode_1.default, { noOfParts: 3, partSize: 3, submitRef: submitRef.current, onChange: setCode }),
        react_1.default.createElement(Button_1.default, { ref: submitRef, color: lib_palette_1.default.secondary, disabled: !isValid, fullWidth: true, onClick: handleSubmit, label: lib_i18n_1.default.t('sign-in-with-teamboard') }),
        react_1.default.createElement(Text_1.default, null, "or"),
        react_1.default.createElement(Button_1.default, { color: lib_palette_1.default.positive, fullWidth: true, onClick: handleGoTo(lib_pages_1.default.AUTH_SIGNIN), label: lib_i18n_1.default.t('sign-in-with-email') }),
        react_1.default.createElement(Button_1.default, { color: lib_palette_1.default.positive, fullWidth: true, onClick: handleGoTo(lib_pages_1.default.AUTH_SIGNIN_PHONE), label: lib_i18n_1.default.t('sign-in-with-phone') })));
}
exports.SignInWithTeamboard = SignInWithTeamboard;
exports.default = SignInWithTeamboard;
